// Initialize Sentry using the global object from CDN
console.log('sentryInit is being loaded');

const initSentry = () => {
  // Skip Sentry initialization in development
  if (process.env.NODE_ENV === 'development' || process.env.REACT_APP_SENTRY_DISABLED) {
    console.log('Sentry disabled in development mode');
    return createFallbackSentry();
  }

  if (window.Sentry) {
    try {
      window.Sentry.init({
        dsn: 'https://54d6d7b096f00b9106b8e59c89790830@o4508881495916544.ingest.us.sentry.io/4508881500766208',
        environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV || 'development',
        replaysSessionSampleRate: 1.0,
        replaysOnErrorSampleRate: 1.0,
        integrations: [
          ...(window.Sentry.Replay
            ? [
                new window.Sentry.Replay({
                  maskAllText: false,
                  maskAllInputs: false,
                  blockAllMedia: false,
                  stickySession: true,
                  minReplayDuration: 1000,
                  slowMotionThreshold: 1000,
                  dataUrlSizeLimit: 20000,
                  errorSampleRate: 1.0,
                }),
              ]
            : []),
        ],
        tracesSampleRate: 0.5,
      });

      // Set user context if available
      if (window.currentUser) {
        window.Sentry.setUser({
          id: window.currentUser.id,
          email: window.currentUser.email,
          role: window.currentUser.role,
        });

        console.log('Sentry user context set');
      }

      console.log('Sentry initialized via CDN');
      return window.Sentry;
    } catch (error) {
      console.error('Error initializing Sentry:', error);
      return createFallbackSentry();
    }
  }
  console.warn('Sentry CDN not loaded');
  return createFallbackSentry();
};

// Create a fallback Sentry object that won't throw errors
const createFallbackSentry = () => ({
  captureException: (error) => console.error('Sentry fallback:', error),
  captureMessage: (message) => console.log('Sentry fallback:', message),
  addBreadcrumb: (breadcrumb) =>
    console.log('Sentry fallback breadcrumb:', breadcrumb),
  setTag: () => {},
  setUser: () => {},
  setExtra: () => {},
  init: () => {},
});

const Sentry = initSentry();

export default Sentry;
